import React, {useState, useEffect} from 'react'
import {Button, Form, Grid, Header, Icon, Image, Message} from "semantic-ui-react";
import pronunciation from "../pictures/pronunciation.png";
import dialogPractice from "../pictures/dialogPractice.png";
import translationFlashCards from "../pictures/translationFlashCards.png";
import dialogFlashCards from "../pictures/dialogFlashCards.png";
import translation from "../pictures/translation.png";
import Plot from "../../node_modules/react-plotly.js/react-plotly";
import StepOneAddPronunciation from "./Add/Pronunciation/StepOneAddPronunciation";
import AddTranslationFlashCardAssignment from "./Add/TranslationFlashCards/AddTranslationFlashCardAssignment";
import AddQuizAssignment from "./Add/Quiz/AddQuizAsignment";
import AddDialogFlashCardAssignment from "./Add/DialogFlashCards/AddDialogFlashCardAssignment";
import AddDialogConversationPage from "./Add/Dialog/AddDialogConversationPage";
import ListAllSoundsPage from "./Sounds/ListAllSoundsPage";
import ListAllPicturesPage from "./Pictures/ListAllPicturesPage";
import AdminSideMenu from "./SideMenu/AdminSideMenu";
import AdminSideMenuWrapper from "./SideMenu/AdminSideMenuWrapper";
import Statistics from '../Statistics/Statistics'
import AddDialogFlashCardComponent from "./Add/DialogFlashCards/AddDialogFlashCardComponent";
import AudioRecordingWrapper from "../Statistics/AudioRecordingWrapper";

function Admin(
    {
        authenticated,
        students,
        pronunciationViewCount,
        dialogConversationViewCount,
        translationViewCount,
        dialogFlashCardViewCount,
        quizzesViewCount,
        dates,
        totalViewCount,
        todaysViews,
        errMsg,
        handleChange,
        submitPassword,
        classLevel,
        handleClassLevel,
        handleSideMenu,
        sideMenu,
        databaseChoice,
        handleSetDatabaseChoice,
        handleSetAction,
        actionChoice,
        mediaChoice,
        handleSetMediaChoice,
        assignment,
        handleSetAssignment,
        closeSideMenu,
        setAssignment
    }
) {
    const [editAssignment, setEditAssignment] = useState(false);
    const [editAssignmentLoading, setEditAssignmentLoading] = useState(false);
    const [editAssignmentProgress, setEditAssignmentProgress] = useState(0);
    const [statisticChoice, setStatisticChoice] = useState('statistics')

    useEffect(()=> {
        setEditAssignment(false)
    },[databaseChoice, classLevel, actionChoice, assignment])

    const handleEditAssignment = () => {
        setEditAssignment(true)
    };

    const handleStatisticChoice = (event, {value}) => {
        setStatisticChoice(value)
    }

    return (

        <>
            {
                authenticated ?
                    <>
                        {
                            sideMenu ?
                                <AdminSideMenuWrapper
                                    handleSideMenu={handleSideMenu}
                                    databaseChoice={databaseChoice}
                                    handleSetDatabaseChoice={handleSetDatabaseChoice}
                                    handleSetAction={handleSetAction}
                                    actionChoice={actionChoice}
                                    mediaChoice={mediaChoice}
                                    handleSetMediaChoice={handleSetMediaChoice}
                                    classLevel={classLevel}
                                    handleClassLevel={handleClassLevel}
                                    assignment={assignment}
                                    handleSetAssignment={handleSetAssignment}
                                    setAssignment={setAssignment}
                                    handleEditAssignment={handleEditAssignment}
                                    editAssignmentLoading={editAssignmentLoading}
                                    editAssignmentProgress={editAssignmentProgress}
                                    editAssignment={editAssignment}
                                    handleStatisticChoice={handleStatisticChoice}
                                    statisticChoice={statisticChoice}
                                />
                                :
                                <Button className='adminMenuButton' floated='right'
                                        style={{marginRight: 10, marginTop: 5}}
                                        onClick={handleSideMenu} color='blue' icon>
                                    <Icon name='bars'/>
                                </Button>

                        }
                        <container onClick={closeSideMenu}>
                            {
                                databaseChoice === "statistics" ?
                                    <div className={sideMenu ? 'dimBackground' : 'statisticsStyle'}>
                                        {
                                            statisticChoice === 'statistics' ?
                                                <Statistics
                                                    students={students}
                                                    pronunciationViewCount={pronunciationViewCount}
                                                    dialogConversationViewCount={dialogConversationViewCount}
                                                    translationViewCount={translationViewCount}
                                                    dialogFlashCardViewCount={dialogFlashCardViewCount}
                                                    quizzesViewCount={quizzesViewCount}
                                                    dates={dates}
                                                    totalViewCount={totalViewCount}
                                                    todaysViews={todaysViews}
                                                />
                                                :
                                                <AudioRecordingWrapper
                                                    statisticChoice={statisticChoice}
                                                    classLevel={classLevel}
                                                    assignment={assignment}
                                                />
                                        }

                                    </div>
                                    :
                                    null
                            }

                            {
                                databaseChoice === "pronunciationAssignments" ?
                                    <div className={sideMenu ? 'dimBackground' : 'statisticsStyle'}>
                                        <StepOneAddPronunciation
                                            classLevel={classLevel}
                                            handleClassLevel={handleClassLevel}
                                            editAssignment={editAssignment}
                                            assignment={assignment}
                                            databaseChoice={databaseChoice}
                                            setEditAssignmentLoading={setEditAssignmentLoading}
                                            setEditAssignmentProgress={setEditAssignmentProgress}
                                        />
                                    </div>
                                    :
                                    null
                            }
                            {
                                databaseChoice === "translationFCAssignments" ?
                                    <div className={sideMenu ? 'dimBackground' : 'statisticsStyle'}>
                                        <AddTranslationFlashCardAssignment
                                            classLevel={classLevel}
                                            handleClassLevel={handleClassLevel}
                                            editAssignment={editAssignment}
                                            assignment={assignment}
                                            databaseChoice={databaseChoice}
                                            setEditAssignmentLoading={setEditAssignmentLoading}
                                            setEditAssignmentProgress={setEditAssignmentProgress}
                                        />
                                    </div>
                                    :
                                    null
                            }
                            {
                                databaseChoice === "dialogFCAssignments" ?
                                    <div className={sideMenu ? 'dimBackground' : 'statisticsStyle'}>
                                        <AddDialogFlashCardAssignment
                                            classLevel={classLevel}
                                            handleClassLevel={handleClassLevel}
                                            editAssignment={editAssignment}
                                            assignment={assignment}
                                            databaseChoice={databaseChoice}
                                            setEditAssignmentLoading={setEditAssignmentLoading}
                                            setEditAssignmentProgress={setEditAssignmentProgress}
                                        />
                                    </div>
                                    :
                                    null
                            }
                            {
                                databaseChoice === "dialogAssignments" ?
                                    <div className={sideMenu ? 'dimBackground' : 'statisticsStyle'}>
                                        <AddDialogConversationPage
                                            classLevel={classLevel}
                                            handleClassLevel={handleClassLevel}
                                            editAssignment={editAssignment}
                                            editAssignmentName={assignment}
                                            actionChoice={actionChoice}
                                            databaseChoice={databaseChoice}
                                            setEditAssignmentLoading={setEditAssignmentLoading}
                                            setEditAssignmentProgress={setEditAssignmentProgress}
                                        />
                                    </div>
                                    :
                                    null
                            }
                            {
                                databaseChoice === "quizAssignments" ?
                                    <div className={sideMenu ? 'dimBackground' : 'statisticsStyle'}>
                                        <AddQuizAssignment
                                            classLevel={classLevel}
                                            handleClassLevel={handleClassLevel}
                                            editAssignment={editAssignment}
                                            assignment={assignment}
                                            editAssignmentLoading={editAssignmentLoading}
                                            setEditAssignmentLoading={setEditAssignmentLoading}
                                            setEditAssignmentProgress={setEditAssignmentProgress}
                                            actionChoice={actionChoice}
                                            databaseChoice={databaseChoice}
                                        />
                                    </div>
                                    :
                                    null
                            }
                        </container>
                    </>
                    :

                    <Grid centered={true}>
                        <Grid.Row></Grid.Row>
                        {
                            errMsg ?
                                <Grid.Row>
                                    <Message negative>
                                        {errMsg}
                                    </Message>
                                </Grid.Row>
                                :
                                null
                        }
                        <Grid.Row>
                            <Form onSubmit={submitPassword}>
                                <Form.Input
                                    type='password'
                                    onChange={handleChange}
                                    label='Password'
                                    placeholder='Enter Password'
                                />
                            </Form>
                        </Grid.Row>

                        <Grid.Row>
                            <Form.Button onClick={submitPassword}>Authorize</Form.Button>
                        </Grid.Row>
                    </Grid>
            }

        </>
    )
}

export default Admin
